var RENDERS;
(function (RENDERS) {
    RENDERS["STRING"] = "STRING.render";
    RENDERS["OPTION"] = "OPTION.render";
    RENDERS["LAYER"] = "LAYER.render";
    RENDERS["URL"] = "URL.render";
    RENDERS["DATE"] = "DATE.render";
    RENDERS["NUMBER"] = "NUMBER.render";
})(RENDERS || (RENDERS = {}));
export const CUSTOM_FIELD_COLUMN_MAP = {
    STRING: {
        width: 250,
        renderer: RENDERS.STRING,
    },
    OPTION: {
        width: 180,
        renderer: RENDERS.OPTION,
    },
    LAYER: {
        width: 180,
        renderer: RENDERS.LAYER,
    },
    URL: {
        width: 160,
        renderer: RENDERS.URL,
    },
    DATE: {
        width: 160,
        renderer: RENDERS.DATE,
    },
    NUMBER: {
        width: 160,
        renderer: RENDERS.NUMBER,
    },
};
